import React, { EventHandler } from 'react';
import classNames from 'classnames';
import { BiomeIcon, IconName } from '@codametrix/verdigris';

type IconHeaderProps = {
  header: string | React.ReactElement;
} & React.HTMLAttributes<HTMLDivElement>;

type IconProperties = {
  svgIconName: IconName;
  svgIconClass?: string;
  svgTitleText?: string;
};

const IconHeader = (props: IconHeaderProps & IconProperties) => {
  const {
    svgIconName,
    svgIconClass,
    svgTitleText,
    className,
    header,
    ...spreadable
  } = props;
  const classes = classNames('icon-divider-title', className);
  return (
    //@ts-ignore
    <div {...spreadable} className="icon-divider">
      <div className={classes}>
        <BiomeIcon
          iconName={svgIconName}
          iconSize="20"
          iconClass={svgIconClass}
          titleText={svgTitleText}
        />
        <h5>{header}</h5>
      </div>
      <div className="cmx-divider" />
    </div>
  );
};

IconHeader.displayName = 'IconHeader';

export { IconHeader };
